module.exports = __webpack_public_path__ + "img/16_RS-junction.a13c8cac.png";